import {
    editNameApi,
    editPhoneApi,
    editPassApi,
    editEmailApi,
    getYzmApi
} from "../../network/api"
const data = function () {
    return {
        dialogFormVisible: false,
        dialogFormVisible2: false,
        msg: true,
        name: '',
        phone: '',
        pass: 'sadasdad',
        email: '',

        nwe_email: '',
        yzm: '',
        codetext: '获取验证码',
        nwe_pass: '',
        old_pwd: '',
        re_pwd: '',
    }
};
const computed = {

}
const methods = {
    complateMsg() {
        this.msg = !this.msg
    },
    // 获取验证码
    getcode() {
        getYzmApi(this.nwe_email).then(res => {
            // console.log(res);
            let time = 60;
            var timer = ''
            if (this.codetext === '获取验证码') {

                timer = setInterval(() => {
                    this.codetext = time-- + 's'
                    if (time == -2) {
                        clearInterval(timer)
                        this.codetext = '获取验证码';
                        return
                    }
                }, 1000);

            }
            this.$message(res.data.msg);
        }).catch()

    },
    editname() {
        let formdata = {
            real_name: this.name,
            token: this.$store.state.userinfo.token,
        }
        editNameApi(formdata).then(res => {
            // console.log(res);
            if (res.data.code == 0) {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
            } else {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
            }

        })
    },
    editphone() {
        let formdata = {
            phone: this.phone,
            token: this.$store.state.userinfo.token,
        }
        editPhoneApi(formdata).then(res => {
            // console.log(res);
            if (res.data.code == 0) {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
            } else {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
            }
        })
    },
    editemail() {
        let formdata = {
            mail: this.nwe_email,
            yzm: this.yzm,
            token: this.$store.state.userinfo.token,
        }
        editEmailApi(formdata).then(res => {
            // console.log(res);
            if (res.data.code == 0) {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
                this.dialogFormVisible = false
                setTimeout(() => {
                    this.$router.push({
                        path: '/index'
                    })
                }, 1500);

            } else {
                this.$message({
                    message: res.data.msg,
                })
            }
        })
    },
    editpass() {
        let formdata = {
            old_pwd: this.old_pwd,
            new_pwd: this.nwe_pass,
            re_pwd: this.re_pwd,
            token: this.$store.state.userinfo.token,
        }
        editPassApi(formdata).then(res => {
            // console.log(res);
            if (res.data.code == 0) {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
                setTimeout(() => {
                    this.$router.push({
                        path: '/index'
                    })
                }, 1500);
                this.dialogFormVisible2 = false

            } else {
                this.$message({
                    message: res.data.msg,
                    type: 'success'
                })
            }
        })
    },


}



export default {
    data,
    computed,
    methods,
}